module.exports = __webpack_public_path__ + "static/img/pexels-daria-shevtsova-1680140.4aa9667.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pexels-daria-shevtsova-1680140.png
// module id = bGi4
// module chunks = 0